<script setup>
import { computed } from 'vue'
import { CHANNEL_CONFIG } from '@/composables/useChannelConfig.js'

const props = defineProps({
  channelType: { type: String, required: true }, // "Channel::Telegram"
  size:        { type: Number, default: 24 }
})

const key = computed(() => {
  switch (props.channelType) {
    case 'Channel::Telegram': return 'telegram'
    case 'Channel::Whatsapp': return 'whatsapp'
    case 'Channel::Line':     return 'line'
    case 'Channel::FacebookMessenger': return 'facebook'
    case 'Channel::Instagram': return 'instagram'
    default: return 'other'
  }
})

const cfg = computed(() => CHANNEL_CONFIG[key.value] || CHANNEL_CONFIG.other)
</script>

<template>
  <span
    class="inline-flex items-center justify-center rounded-full text-[11px] font-semibold"
    :style="{
      width:  size + 'px',
      height: size + 'px',
      backgroundColor: cfg.color || 'var(--accentSoft)',
      color:           cfg.color ? '#fff' : 'var(--accent)'
    }"
    :title="cfg.label"
  >
    {{ cfg.initials }}
  </span>
</template>
